import { createSelector } from 'reselect';
import get from 'lodash/get';
import { RootState } from 'stores/reducers';

const getPageModelDomain = (state: RootState) => state.domains.pageModel;

export const getPageModel = createSelector(getPageModelDomain, pageModelDomain => pageModelDomain.model);

export const getPageModelIsLoading = createSelector(
  getPageModelDomain,
  pageModelDomain => pageModelDomain.loading
);

export const getPageModelIsLoaded = createSelector(
  getPageModelDomain,
  pageModelDomain => pageModelDomain.loaded
);

export const getGtmCode = createSelector(getPageModel, model => get(model, 'analytics.gtmCode'));
